import React, { lazy, Suspense } from 'react';

const LazyMobileLandscape = lazy(() => {
  return import('./MobileLandscape' /* webpackChunkName: "MobileLandscape" */).then((i) => {
    return {
      default: i.MobileLandscape,
    };
  });
});

export const MobileLandscape = () => (
  <Suspense fallback={null}>
    <LazyMobileLandscape />
  </Suspense>
);
